































































import Vue from 'vue'
import getStoriesSearchPage from '~/apollo/queries/getStoriesSearchPage.gql'
import searchStories from '~/apollo/queries/searchStories.gql'
import StoryGallery from '~/components/StoryGallery.vue'
import SvgImage from '~/components/SvgImage.vue'

export default Vue.extend({
  name: 'Stories',
  components: {
    StoryGallery,
    SvgImage
  },
  async fetch () {
    const getStoriesSearchPageQuery = await this.$apolloProvider.defaultClient.query({
      query: getStoriesSearchPage
    })
    this.pageData = getStoriesSearchPageQuery.data.page[0]

    if (!this.loadingNext) {
      this.loadingNext = true
      this.pageNum++

      const searchStoriesQuery = await this.$apolloProvider.defaultClient.query({
        query: searchStories,
        variables: {
          first: this.pageSize,
          skip: this.pageNum * this.pageSize,
          searchTerm: this.$route.query.term
        }
      })
      this.stories = [...(this.stories !== null ? this.stories : []), ...searchStoriesQuery.data.stories]
      this.searchTerm = this.$route.query.term as string
      this.isLastPage = searchStoriesQuery.data.stories.length === 0
      this.loadingNext = false

      if ((this.stories && this.stories.length > 0) || !this.searchTerm || this.searchTerm === '') {
        this.showNotFound = false
      } else {
        this.showNotFound = true
      }
    }
  },
  data () {
    return {
      pageData: null as any,
      stories: [] as any,
      searchTerm: '',
      pageNum: -1,
      pageSize: 9,
      isLastPage: false,
      loadingNext: false,
      showNotFound: false
    }
  },
  mounted () {
    window.addEventListener('scroll', this.checkIfWindowBottom)
  },
  destroyed () {
    window.removeEventListener('scroll', this.checkIfWindowBottom)
  },
  methods: {
    checkIfWindowBottom () {
      if (process.client) {
        const bottomOfWindow = (Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop) + window.innerHeight + 5) > (document.documentElement.offsetHeight - 350)

        if (bottomOfWindow) {
          if (!this.isLastPage && !this.loadingNext) {
            (this.$fetch() as any).then(this.checkIfWindowBottom)
          }
        }
      }
    },
    async search () {
      this.$router.push({ path: '/stories/search', query: { term: this.searchTerm } })

      this.pageNum = 0
      this.isLastPage = false

      const { data } = await this.$apolloProvider.defaultClient.query({
        query: searchStories,
        variables: {
          first: this.pageSize,
          skip: this.pageNum * this.pageSize,
          searchTerm: this.searchTerm
        }
      })
      this.stories = data.stories

      if ((this.stories && this.stories.length > 0) || !this.searchTerm || this.searchTerm === '') {
        this.showNotFound = false
      } else {
        this.showNotFound = true
      }
    }
  },
  head (): any {
    return {
      title: this.pageData ? this.pageData.metaTitle : '',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.pageData ? this.pageData.metaDescription : ''
        }
      ]
    }
  }
})
